import { stringifyArgs } from "./stringify-args.js";

const logFunctions = {
  debug: window.console.debug,
  error: window.console.error,
  info: window.console.info,
  log: window.console.log,
  warn: window.console.warn,
};

Object.keys(logFunctions).forEach((level) => {
  window.console[level] = (...args) => {
    if (window.api) {
      window.api.logToFile([level, ...stringifyArgs({ args })]);
    }

    const timestamp = `[${new Date().toISOString()}]`;

    args.unshift(timestamp);

    logFunctions[level].apply(console, args);
  };
});
